/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Warm_Lynx_LinkInputs */

const en_bold_warm_lynx_link = /** @type {(inputs: Bold_Warm_Lynx_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AND`)
};

const de_bold_warm_lynx_link = /** @type {(inputs: Bold_Warm_Lynx_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UND`)
};

/**
* | output |
* | --- |
* | "AND" |
*
* @param {Bold_Warm_Lynx_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_warm_lynx_link = /** @type {((inputs?: Bold_Warm_Lynx_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Warm_Lynx_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_warm_lynx_link(inputs)
	return de_bold_warm_lynx_link(inputs)
});